import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconRemoveCircleOutlineSvg } from "./IconRemoveCircleOutlineSvg.mjs";
const IconRemoveCircleOutline = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconRemoveCircleOutlineSvg, ...iconProps });
};
export {
  IconRemoveCircleOutline
};
